import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetItemResponse, ItemResponse } from './types';

export const getItem = async (itemId: string, priceSchemeId: string | null): Promise<ItemResponse | null> => {
  const url = `${API_URL}/items/${itemId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      ...(priceSchemeId ? { [PRICE_SCHEME_HEADER]: priceSchemeId } : {}),
      'Content-Type': 'application/json',
    },
  });

  const res = (await response.json()) as IGetItemResponse;
  return res?.data?.[0] ?? null;
};
